/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosLink, CosmosText, CosmosTextVariantEnum, EdsIcon } from "@components/elements";
import { CosmosLinkFragment } from "@cosmos/hygraph-schema";
import { css, cx } from "@panda/css";
import { HStack } from "@panda/jsx";

const styles = css({
	borderRadius: "eds.dimension.16",
	paddingInline: "eds.dimension.32",
	paddingBlock: "eds.dimension.24",
	transition: `background token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)`,
	display: "flex",
	justifyContent: "center",
	background: "eds.palette.transparent.light.005",
	_hover: {
		background: "eds.material.elevated.high.strong",
	},
});

export function LicenseCollapsedCta({ label, href, icon, iconPosition }: CosmosLinkFragment): React.JSX.Element | null {
	if (!href) return null;
	return (
		<CosmosLink
			className={cx("license-collapsed-cta", styles)}
			href={href}
			analytics={{
				eventCategory: "hyperlink",
				eventLabel: label || "",
				eventValue: {
					component: "LicenseCollapsedCta",
					icon,
					href,
				},
			}}
		>
			<CosmosText variant={CosmosTextVariantEnum.paragraphMD} color="eds.text.primary">
				<HStack justifyContent="center" alignItems="center" gap="eds.dimension.4">
					{iconPosition !== "start" && label}
					{icon && <EdsIcon size="sm" icon={icon} color="primary" />}
					{iconPosition === "start" && label}
				</HStack>
			</CosmosText>
		</CosmosLink>
	);
}
